import { render, staticRenderFns } from "./ShoppingContent.vue?vue&type=template&id=16aed5d4&"
import script from "./ShoppingContent.vue?vue&type=script&lang=js&"
export * from "./ShoppingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports